import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingViewSection } from '#/modules/listing/components/ListingView/Section/ListingViewSection';
import {
  listingRichTextTruncateAtAbout8Lines,
  ListingRichTextTruncated,
} from '#/modules/listing/components/RichText/Truncated/ListingRichTextTruncated';

type Props = {
  benefits: string | null;
  benefitsTruncated: string | null;
  onToggleDetails?: (isOpen: boolean) => void;
};

export function ListingViewBenefitsSection({
  benefits,
  benefitsTruncated,
  onToggleDetails,
}: Props) {
  const { i18n } = useI18n();

  if (!benefits || !benefitsTruncated) return null;

  return (
    <ListingViewSection
      title={
        /* TRANSLATORS: Listing Page, section title */
        i18n('Benefits')
      }
    >
      <ListingRichTextTruncated
        showMoreLinkTitle={i18n('Read more about benefits')}
        showLessLinkTitle={i18n('Read less about benefits')}
        html={benefits}
        truncateAtHeight={
          benefitsTruncated === benefits
            ? null
            : listingRichTextTruncateAtAbout8Lines
        }
        onToggle={onToggleDetails}
        toggleQAId="show-listing-benefits-toggle"
      />
    </ListingViewSection>
  );
}
